import { paths } from "api/schema/api-schema";
import assert from "assert";
import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import { ToolSpec } from "types/json-schemas/type_guards";

type WorkflowToolSpecParam = ToolSpec["params"][number];

const path = "/wrs/workflow/validate_tables/" satisfies keyof paths;

type WorkflowGraph =
  paths[typeof path]["post"]["responses"][200]["content"]["application/json"];

// The backend doesn't have typing yet for tool spec parameters, so keep same narrowing (?) as before
type WithToolSpecParam<T> = Omit<T, "param"> & { param: WorkflowToolSpecParam };

export type ValidateTablesResponse = Omit<
  WorkflowGraph,
  "inputs" | "parameters"
> & {
  inputs: WithToolSpecParam<WorkflowGraph["inputs"][number]>[];
  parameters: WithToolSpecParam<WorkflowGraph["parameters"][number]>[];
};

export const workflowValidateTables = djangoClientQueryFactory(
  { path, method: "post" },
  {
    formatInput: (
      body: paths[typeof path]["post"]["requestBody"]["content"]["application/json"],
    ) => ({ body }),
    handleResponse: (res) => {
      const data = res.data;
      assert(data !== undefined, "Expected data to be defined in response");
      return data as ValidateTablesResponse;
    },
  },
);
